import React from 'react';
import { IconBuilding, IconClock, IconNetwork, IconNotes, IconSettingsCog } from '@tabler/icons-react';
import { messageTimeLabel } from '../utils/boardChatUtils';
import './BoardChatEquipmentChangeCard.css';

const FIELDS = [
  { key: 'setor', label: 'Novo setor', Icon: IconBuilding },
  { key: 'enderecoIp', label: 'Novo endereço IP', Icon: IconNetwork, mono: true },
  { key: 'outros', label: 'Outros assuntos', Icon: IconNotes, multiline: true },
];

const EQUIP_PREFIXES = [
  { re: /^s[ée]rie\s*:?\s*/i, label: 'Série' },
  { re: /^patrim[oô]nio\s*:?\s*/i, label: 'Patrimônio' },
  { re: /^contrato\s*:?\s*/i, label: 'Contrato' },
];

function text(v) {
  return typeof v === 'string' ? v.trim() : v != null ? String(v).trim() : '';
}

/** "Modelo · Série X · Patrimônio Y · Contrato Z · Cliente" → linhas rotuladas. */
function parseEquipmentLabel(label) {
  const parts = label.split(/\s+·\s+/).map((p) => p.trim()).filter(Boolean);
  return parts.map((part, idx) => {
    const prefix = EQUIP_PREFIXES.find((p) => p.re.test(part));
    if (prefix) return { label: prefix.label, value: part.replace(prefix.re, '') };
    if (idx === 0) return { label: 'Equipamento', value: part, strong: true };
    return { label: 'Cliente', value: part };
  });
}

/**
 * Nota estruturada "Alteração de equipamento" (time de contratos).
 * Fonte de verdade: content_attributes; o content é só fallback do Chatwoot.
 */
export function parseEquipmentChangeMessage(message) {
  const attrs = message?.content_attributes || message?.contentAttributes || null;
  if (!attrs || typeof attrs !== 'object' || attrs.tipo !== 'alteracao_equipamento') return null;
  const changes = attrs.alteracoes && typeof attrs.alteracoes === 'object' ? attrs.alteracoes : {};
  const rows = FIELDS.map((f) => ({ ...f, value: text(changes[f.key]) })).filter((f) => f.value);
  const equipmentLabel = text(attrs.equipamento_label);
  return { equipment: equipmentLabel ? parseEquipmentLabel(equipmentLabel) : [], rows };
}

export function BoardChatEquipmentChangeCard({ data, createdAt }) {
  const timeLabel = messageTimeLabel(createdAt);
  return (
    <div className="bch-eqc-card">
      <div className="bch-eqc-head">
        <span className="bch-eqc-head-icon" aria-hidden>
          <IconSettingsCog size={15} stroke={1.8} />
        </span>
        <div className="bch-eqc-head-copy">
          <span className="bch-eqc-title">Aviso de mudança interna</span>
        </div>
        <div className="bch-eqc-head-right">
          {timeLabel ? (
            <span className="bch-eqc-time">
              <IconClock size={11} stroke={1.8} aria-hidden />
              {timeLabel}
            </span>
          ) : null}
          <span className="bch-eqc-tag" title="Visível apenas para a equipe">
            Nota interna
          </span>
        </div>
      </div>
      {data.equipment.length ? (
        <dl className="bch-eqc-equip">
          {data.equipment.map((item, idx) => (
            <div key={`${item.label}-${idx}`} className="bch-eqc-equip-row">
              <dt>{item.label}</dt>
              <dd className={item.strong ? 'is-strong' : undefined}>{item.value}</dd>
            </div>
          ))}
        </dl>
      ) : null}
      <div className="bch-eqc-body">
        {data.rows.length ? (
          data.rows.map(({ key, label, Icon, value, mono, multiline }) => (
            <div key={key} className="bch-eqc-row">
              <span className="bch-eqc-row-icon" aria-hidden>
                <Icon size={13} stroke={1.8} />
              </span>
              <span className="bch-eqc-label">{label}</span>
              <span
                className={`bch-eqc-val${mono ? ' bch-eqc-val--mono' : ''}${
                  multiline ? ' bch-eqc-val--multiline' : ''
                }`}
              >
                {value}
              </span>
            </div>
          ))
        ) : (
          <span className="bch-eqc-empty">Nenhuma alteração informada.</span>
        )}
      </div>
    </div>
  );
}
